import {Button, Container, Modal} from "react-bootstrap";
import {useCookies} from "react-cookie";
import Cookies from "js-cookie";
import {useEffect} from "react";

function SessionExpirePopup(props) {
    const [cookie, setCookie] = useCookies(['jwt-token']);
  const baseUrl = window.location.origin;
    const handleClose = () => {
        props.handleChangeValue('sessionTimeout', props.inputValues.sessionTimeout + 1);
        let jwt = Cookies.get('jwt-token');
        setCookie('jwt-token', jwt, {
            path: '/',
            maxAge: props.inputValues.sessionTimeout
        });
        props.handleChangeValue('showCookieExpiryPopup', false);
        props.handleChangeValue('expireSession', false);
    };
  useEffect(() => {
    if (props.inputValues.showCookieExpiryPopup) {
      if (!window.location.hostname.includes('aa')) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'mbiAutosureEvent',
          category: 'Session About to Expired',
          virtualUrl: `${baseUrl}/mbi/`,
          pageTitle: 'Session Expire Popup',
        });
      }
    }
  }, [props.inputValues.showCookieExpiryPopup]);

    return (
        <>
            <Modal
                show={props.inputValues.showCookieExpiryPopup}
                onHide={handleClose}

                backdrop="static"
                size="lg"
                keyboard={false}
            >
                <Modal.Header closeButton>
                    <Modal.Title className="mediumTextStyles"><span style={{color: 'red'}}>Your session is about to expire.</span> </Modal.Title>
                </Modal.Header>

                <Modal.Body className="regularTextStyles">
                    <p>
                        To carry on looking at insurance, please click "Continue".
                    </p>
                </Modal.Body>
                <Modal.Footer>
                    <Container style={{display:'flex', justifyContent:'center'}}>
                        <Button variant="secondary" onClick={handleClose}>
                            Continue
                        </Button>
                    </Container>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default SessionExpirePopup;
